import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import { Actions, Action, PermissionsList } from 'states';
import { CheckBoxField } from 'components/core/fields/CheckBoxField';
import 'styles/global.css';

export const Permissions = () => {
  const { t } = useTranslation();
  const actions = useRecoilValue(Actions);
  const permissionsList = useRecoilValue(PermissionsList);

  return (
    <>
      <div className="row scroll">
        <p className="category">{t('ROLE.CATEGORY_DASHBOARD')}</p>
        {actions.length > 0 &&
          actions.map((action: Action) => {
            if (
              action.displayName.toLowerCase().includes('chart') ||
              action.displayName.toLowerCase().includes('dashboard') ||
              action.displayName.toLowerCase().includes('visualization')
            ) {
              return (
                <div className="col-sm-12 col-md-4 col-lg-4 mt-3" key={action.id}>
                  <CheckBoxField
                    label={action.displayName}
                    isChecked={permissionsList.includes(action.id)}
                  />
                </div>
              );
            }
          })}
        <p className="category">{t('ROLE.CATEGORY_MASTER')}</p>
        {actions.length > 0 &&
          actions.map((action: Action) => {
            if (action.displayName.toLowerCase().includes('org')) {
              return (
                <div className="col-sm-12 col-md-4 col-lg-4 mt-3" key={action.id}>
                  <CheckBoxField
                    label={action.displayName}
                    isChecked={permissionsList.includes(action.id)}
                  />
                </div>
              );
            }
          })}
        <p className="category">{t('ROLE.CATEGORY_USER')}</p>
        {actions.length > 0 &&
          actions.map((action: Action) => {
            if (
              action.displayName.toLowerCase().includes('user') ||
              action.displayName.toLowerCase().includes('role')
            ) {
              return (
                <div className="col-sm-12 col-md-4 col-lg-4 mt-3" key={action.id}>
                  <CheckBoxField
                    label={action.displayName}
                    isChecked={permissionsList.includes(action.id)}
                  />
                </div>
              );
            }
          })}
        <p className="category">{t('ROLE.CATEGORY_FORMS')}</p>
        {actions.length > 0 &&
          actions.map((action: Action) => {
            if (action.displayName.toLowerCase().includes('form')) {
              return (
                <div className="col-sm-12 col-md-4 col-lg-4 mt-3" key={action.id}>
                  <CheckBoxField
                    label={action.displayName}
                    isChecked={permissionsList.includes(action.id)}
                  />
                </div>
              );
            }
          })}
        <p className="category">{t('ROLE.CATEGORY_COUNTRY')}</p>
        {actions.length > 0 &&
          actions.map((action: Action) => {
            if (action.displayName.toLowerCase().includes('country')) {
              return (
                <div className="col-sm-12 col-md-4 col-lg-4 mt-3" key={action.id}>
                  <CheckBoxField
                    label={action.displayName}
                    isChecked={permissionsList.includes(action.id)}
                  />
                </div>
              );
            }
          })}
        <p className="category">{t('ROLE.CATEGORY_OTHERS')}</p>
        {actions.length > 0 &&
          actions.map((action: Action) => {
            if (
              !(
                action.displayName.toLowerCase().includes('form') ||
                action.displayName.toLowerCase().includes('user') ||
                action.displayName.toLowerCase().includes('role') ||
                action.displayName.toLowerCase().includes('org') ||
                action.displayName.toLowerCase().includes('chart') ||
                action.displayName.toLowerCase().includes('dashboard') ||
                action.displayName.toLowerCase().includes('visualization') ||
                action.displayName.toLowerCase().includes('country')
              )
            ) {
              return (
                <div className="col-sm-12 col-md-4 col-lg-4 mt-3" key={action.id}>
                  <CheckBoxField
                    label={action.displayName}
                    isChecked={permissionsList.includes(action.id)}
                  />
                </div>
              );
            }
          })}
      </div>
    </>
  );
};
